export default "__VITE_ASSET__BfdK2lct__"